import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  transferForm = new BehaviorSubject<any>(null);
  sendData = new BehaviorSubject<any>(null);
  apiUrl: string;

  constructor(private http: HttpClient, private store: Store<{ config: any }>) {
    store.select('config').subscribe((res) => {
      this.apiUrl = res.apiUrl;
    });
  }

  toggleStatus(id: number) {
    return this.http.patch<any>(`${this.apiUrl}/api/pages/${id}/toggle`, {});
  }
}
